module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/core-js/library/modules/_iter-step.js
// module id = 1042
// module chunks = 0